import React, { createContext, useContext, useMemo } from 'react';
import { ChartsTheme, ChartsThemePadding } from '../model';
import { PanelTooltipProvider } from '../PanelTooltip/PanelTooltipProvider';

export interface ChartsProviderProps {
  chartsTheme: ChartsTheme;
  enablePinning?: boolean;
  children?: React.ReactNode;
}

export interface SharedChartsState {
  chartsTheme: ChartsTheme;
  enablePinning: boolean;
}

export function ChartsProvider(props: ChartsProviderProps) {
  const { children, chartsTheme, enablePinning = false } = props;

  const ctx = useMemo(() => {
    return {
      chartsTheme,
      enablePinning,
    };
  }, [chartsTheme, enablePinning]);

  return (
    <ChartsThemeContext.Provider value={ctx}>
      <PanelTooltipProvider>{children}</PanelTooltipProvider>
    </ChartsThemeContext.Provider>
  );
}

export const ChartsThemeContext = createContext<SharedChartsState | undefined>(undefined);

export function useChartsContext(): SharedChartsState {
  const ctx = useContext(ChartsThemeContext);
  if (ctx === undefined) {
    throw new Error('No ChartsThemeContext found. Did you forget a Provider?');
  }
  return ctx;
}

export function useChartsTheme(): ChartsTheme {
  const ctx = useChartsContext();
  return ctx.chartsTheme;
}

export function useContainerPadding(): { containerPadding: ChartsThemePadding } {
  const ctx = useChartsContext();
  return { containerPadding: ctx.chartsTheme.container.padding };
}
